var map = {
	"./pages/admin/admin.module": [
		"./src/app/pages/admin/admin.module.ts",
		"pages-admin-admin-module"
	],
	"./pages/agente/agente.module": [
		"./src/app/pages/agente/agente.module.ts",
		"pages-agente-agente-module"
	],
	"./pages/capturista/capturista.module": [
		"./src/app/pages/capturista/capturista.module.ts",
		"pages-capturista-capturista-module"
	],
	"./pages/public/public.module": [
		"./src/app/pages/public/public.module.ts",
		"pages-public-public-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;